module.exports = __webpack_public_path__ + "static/media/faq-banner-graphic.d3da8f87.png";